// import React from 'react';
// import logo from '../assets/rem-logo.png';

// const Footer = () => {
//     return (
//         <div className="relative bg-white rounded-md ">
//             {/* Add shadow on top using pseudo-element */}
//             <div 
//                 className="absolute top-0 left-0 w-full h-2 shadow-lg shadow-gray-600"
//                 style={{ transform: 'translateY(-100%)' }} // Shift shadow above the container
//             ></div>

//             <div className='container px-4 2xl:px-20 mx-auto flex items-center justify-between gap-4 py-3 mt-20'>
//                 <img
//                     // width={160}
//                     src={logo}
//                     alt="REM Logo"
//                     className="bg-purple-800 rounded-full w-20"
//                 />
//                 <p className="flex-1 border-1 border-gray-400 pl-4 text-sm text-gray-800 max-sm:hidden">
//                     Copyright @Powergenic Engineering | All Right Reserved.
//                 </p>
//                 <div className="flex flex-row gap-2 font-medium mt-4">
//                     <a
//                         className="text-4xl shadow-lg hover:shadow-2xl hover:scale-110 transition-all duration-300 rounded-full text-blue-700 hover:text-purple-800"
//                         href="#"
//                     >
//                         <ion-icon name="logo-chrome"></ion-icon>
//                     </a>
//                     <a
//                         className="text-4xl shadow-lg hover:shadow-2xl hover:scale-110 transition-all duration-300  text-blue-700 hover:text-purple-800"
//                         href="#"
//                     >
//                         <ion-icon name="logo-linkedin"></ion-icon>
//                     </a>
//                     <a
//                         className="text-4xl shadow-lg hover:shadow-2xl hover:scale-110 transition-all duration-300 rounded-full text-blue-700 hover:text-purple-800"
//                         href="#"
//                     >
//                         <ion-icon name="logo-facebook"></ion-icon>
//                     </a>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default Footer;



import React from 'react';
import logo from '../assets/rem-logo.png';
import VisitCounter from './VisitCounter';


const Footer = () => {
  return (
    <div className="relative bg-gray-300 dark:bg-black rounded-md shadow-lg">
      {/* Add shadow on top using pseudo-element */}
      <div
        className="absolute top-0 left-0 w-full h-1 bg-purple-800"
        style={{ transform: 'translateY(-100%)' }} // Shift shadow above the container
      ></div>

      <div className='container px-4 2xl:px-20 mx-auto flex flex-col md:flex-row items-center justify-between gap-6 py-6 mt-20'>
        {/* Logo Section */}
        <div className="flex items-center gap-4">
          <img
            src={logo}
            alt="REM Logo"
            className="w-20 h-20 bg-purple-800 rounded-full"
          />
          <div className="text-xl font-bold text-gray-800 dark:text-white">Powergenic Engineering</div>
        </div>

        {/* Copyright & Text */}
        {/* <p className="text-sm flex justify-center  text-gray-800 dark:text-white text-center md:text-left max-sm:mt-4">
          Copyright &copy; {new Date().getFullYear()} Powergenic Engineering | All Rights Reserved.

          <VisitCounter />
        </p> */}

        <p className="text-sm flex items-center justify-center text-gray-800 dark:text-white text-center mt-4 space-x-2 max-sm:hidden">
          <span className='pr-10'>Copyright &copy; {new Date().getFullYear()} Powergenic Engineering | All Rights Reserved.</span>
          <VisitCounter />
        </p>



        {/* Social Media Links */}
        {/* <div className="flex gap-6 mt-4 md:mt-0">
          <a
            className="text-3xl text-purple-800 hover:text-blue-700 dark:text-white hover:scale-110 transition-all duration-300 "
            href="https://g.co/kgs/tcmXsD3"
            aria-label="Chrome"
          >
            <ion-icon name="logo-chrome"></ion-icon>
          </a>
          <a
            className="text-3xl text-purple-800 hover:text-blue-700 dark:text-white hover:scale-110 transition-all duration-300"
            href="https://www.linkedin.com/company/powergenic-engineering-technical-expertise/"
            aria-label="LinkedIn"
          >
            <ion-icon name="logo-linkedin"></ion-icon>
          </a>
          <a
            className="text-3xl text-purple-800 hover:text-blue-700 dark:text-white hover:scale-110 transition-all duration-300"
            href="https://www.facebook.com/share/1BZW3qNodB/"
            aria-label="Facebook"
          >
            <ion-icon name="logo-facebook"></ion-icon>
          </a>
        </div> */}

        <div className="flex items-center justify-center gap-6 mt-4 md:mt-0">
          {[
            { name: "logo-chrome", link: "https://g.co/kgs/tcmXsD3", label: "Chrome" },
            { name: "logo-linkedin", link: "https://www.linkedin.com/company/powergenic-engineering-technical-expertise/", label: "LinkedIn" },
            { name: "logo-facebook", link: "https://www.facebook.com/share/1BZW3qNodB/", label: "Facebook" },
          ].map((social, index) => (
            <a
              key={index}
              className="text-4xl text-purple-800  hover:text-blue-700 hover:scale-110 transition-transform duration-300 ease-in-out p-2 rounded-lg  "
              href={social.link}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={social.label}
            >
              <ion-icon name={social.name}></ion-icon>
            </a>
          ))}
        </div>


        <div className='hidden text-center justify-center max-sm:block'>
          <p>
            Copyright &copy; {new Date().getFullYear()} Powergenic Engineering | All Rights Reserved.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
